import staticMapUrl from '../staticMapUrl';
import staticMapView from '../staticMapView';

// A Map ID has one map type, so Static Maps need their own id on the KOOB
// style (packages/maps/README.md).
const GOOGLE_MAPS_STATIC_MAP_ID =
  process.env.REACT_APP_GOOGLE_MAPS_STATIC_MAP_ID;

const MARKER_WIDTH_PX = 45;
const MARKER_HEIGHT_PX = 60;

/**
 * A Static Maps image with the app's own SVG pictos overlaid in CSS.
 *
 * Static Maps cannot render SVG marker icons, and shipping raster copies
 * would fork the pictos away from @koob/map-marker — so the map is requested
 * without markers and the pins are absolutely-positioned <img> elements,
 * placed by the same Web Mercator projection that chose the center/zoom.
 *
 * The inner box replicates the previous `object-cover`: it keeps the
 * requested image's aspect ratio and grows to cover the container (centered,
 * cropped by overflow-hidden), so the percentage offsets stay glued to the
 * map pixels whatever the container's shape.
 */
export default function ExportStaticMap({
  points,
  apiKey,
  width,
  height,
  icon,
  className,
  style,
  ...rest
}) {
  const view = staticMapView(points, { width, height });

  return (
    <div
      className={`relative overflow-hidden ${className ?? ''}`}
      style={style}
      {...rest}
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <div
          className="relative"
          style={{
            aspectRatio: `${width} / ${height}`,
            minWidth: '100%',
            minHeight: '100%',
            flexShrink: 0,
          }}
        >
          <img
            className="absolute inset-0 h-full w-full"
            src={staticMapUrl({
              apiKey,
              size: `${width}x${height}`,
              center: view.center,
              zoom: view.zoom,
              mapId: GOOGLE_MAPS_STATIC_MAP_ID,
            })}
            alt=""
          />
          {view.markers.map((marker, index) => (
            <img
              key={`${marker.lat},${marker.lon},${index}`}
              className="absolute"
              style={{
                left: `${marker.leftPct}%`,
                top: `${marker.topPct}%`,
                width: `${marker.point?.markerWidth ?? MARKER_WIDTH_PX}px`,
                height: `${marker.point?.markerHeight ?? MARKER_HEIGHT_PX}px`,
                maxWidth: 'none',
                transform: marker.point?.anchorCenter
                  ? 'translate(-50%, -50%)'
                  : 'translate(-50%, -100%)',
              }}
              src={marker.point?.icon ?? icon}
              alt=""
            />
          ))}
        </div>
      </div>
    </div>
  );
}
